import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import useWizardExit from '@swf/core/hooks/useWizardExit';
import { select } from '@swf/core/store';
import AccountVerification from '@swf/verification/AccountVerification/AccountVerification';

import CTAButton from '../../../../../CTAButton/CTAButton';
import HelpModal from '../../../../../HelpModal/HelpModal';

import {
  TXTCLI_LetXs_get_you_verified,
  TXTCLI_Verify_account,
  TXTWCL_Verify,
  TXTWCL_You_have_N0_days_1
} from './VerifyAccount.messages.json';
import { container, cta, description } from './VerifyAccount.scss';

export const VerifyAccount: React.FC = () => {
  const [panelVisible, setPanelVisible] = useState(false);
  const exitWizard = useWizardExit();
  const isRomania = useSelector(select.cms.getSiteId) === Sites.ROM;

  return (
    <>
      <div className={container}>
        <div className={description}>
          <strong>
            <Translation {...TXTCLI_Verify_account} />
          </strong>
          <h3>
            <Translation {...TXTWCL_You_have_N0_days_1} values={{ 0: 30 }} />
          </h3>
        </div>
        <div className={cta}>
          <CTAButton
            type="button"
            translation={TXTWCL_Verify}
            onClick={() => setPanelVisible(true)}
            variant={isRomania ? 'secondary' : 'primary'}
          />
        </div>
      </div>
      <HelpModal
        visible={panelVisible}
        onClose={() => setPanelVisible(false)}
        title={TXTCLI_LetXs_get_you_verified}
        hideProgressBar
      >
        <AccountVerification
          openIDScan
          showButton
          onComplete={exitWizard}
          onClose={() => setPanelVisible(false)}
          handleCancel={() => setPanelVisible(false)}
        />
      </HelpModal>
    </>
  );
};
